export default __webpack_public_path__ + "static/media/group3.93855b5c.png";